"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._HideErrorMessage = exports._ShowErrorMessageTimed = exports._ShowErrorMessage = exports._DeleteLoadingScreen = exports._CreateLoadingScreen = exports._GetComponentLoadingSpinner = exports._GetCountryDropdown = exports._GetPhonePrefixDropdown = exports._CreateElements = exports._TwoColSetup = exports._GetGeneric = exports._GetDividerLine = exports._GetCol = exports._GetRow = exports._Theme = exports._CreateDropdown = void 0;
var dropdown_const_1 = require("@src/reusable-css/dropdown.const");
var loading_const_1 = require("@src/reusable-css/loading.const");
var css_injector_service_1 = require("@src/services/css-injector.service");
var cash_dom_1 = __importDefault(require("cash-dom"));
var translation_1 = __importDefault(require("../../services/translation"));
var countries_const_1 = require("../countries.const");
var input_output_helper_const_1 = require("../input-output-helper.const");
var input_mapping_const_1 = require("../input.mapping.const");
var jquery_helper_const_1 = require("./jquery-helper.const");
var helper_const_1 = require("../helper.const");
/**
 *
 * @param type identifier for the dropdown
 * @param mainKey object key in array to show value in dropdown
 * @param dropdownContent dropdown array
 * @param callback
 * @param preselect String, value of the entry that should be preselected on load, does just call the callback of the preselected element
 */
var _CreateDropdown = function (type, mainKey, dropdownContent, callback) {
    if (callback === void 0) { callback = function (entry) { }; }
    var dropdownContainer = (0, cash_dom_1.default)("#".concat(type, "-container"));
    if (dropdownContainer === null || dropdownContainer === void 0 ? void 0 : dropdownContainer.length) {
        var preselect_1 = dropdownContainer.data('set');
        (0, css_injector_service_1._InjectCss)('_DropdownStyles', dropdown_const_1._DropdownStyles);
        var dropdownButton_1 = dropdownContainer.find('.w-button');
        if ((dropdownButton_1 === null || dropdownButton_1 === void 0 ? void 0 : dropdownButton_1.length) === 0) {
            dropdownButton_1 = dropdownContainer.find('.button');
        }
        if (dropdownButton_1 === null || dropdownButton_1 === void 0 ? void 0 : dropdownButton_1.length) {
            preselect_1 = preselect_1 || dropdownButton_1.text();
            //console.log('dropdown preselecting value:', preselect);
            var entryFieldsContainer_1 = (0, cash_dom_1.default)('<div>').addClass('dropdown-entry-container');
            entryFieldsContainer_1.hide();
            var searchField = (0, cash_dom_1.default)('<input>')
                .addClass('search-field')
                .attr('placeholder', 'Suche...');
            searchField.on('keyup', function (event) {
                var _a;
                var searchText = ((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a['value']) || '';
                generateSelection_1((searchText === null || searchText === void 0 ? void 0 : searchText.length) ? searchText : undefined);
            });
            var dropdownEntries = (0, cash_dom_1.default)('<div></div>').addClass('dropdown-entries');
            var searchFieldContainer_1 = (0, cash_dom_1.default)('<div>')
                .addClass('dropdown-entry')
                .css('padding', '0px')
                .css('min-width', '300px');
            searchFieldContainer_1.append(searchField);
            searchFieldContainer_1.hide();
            dropdownEntries.append(searchFieldContainer_1);
            dropdownButton_1.on('click', function () {
                entryFieldsContainer_1.toggle();
                searchFieldContainer_1.toggle();
            });
            var generateSelection_1 = function (searchText) {
                entryFieldsContainer_1.html('');
                var preselected = false; // used for the info if preselect was set in webflow but didnt find an entry
                dropdownContent.forEach(function (entry) {
                    var dropdownElement = (0, cash_dom_1.default)('<div>')
                        .addClass('dropdown-entry')
                        .text(entry.text)
                        .on('click', function () {
                        entryFieldsContainer_1.toggle();
                        searchFieldContainer_1.toggle();
                        dropdownButton_1.html(entry[mainKey]);
                        if (entry) {
                            callback(entry);
                        }
                    });
                    if (searchText === null || searchText === void 0 ? void 0 : searchText.length) {
                        if (translation_1.default
                            .t(entry.text)
                            .toLowerCase()
                            .includes(searchText.toLowerCase())) {
                            dropdownElement.appendTo(entryFieldsContainer_1);
                        }
                    }
                    else {
                        dropdownElement.appendTo(entryFieldsContainer_1);
                    }
                    // preselect certain key
                    if (preselect_1 && preselect_1 === entry[mainKey]) {
                        callback(entry);
                        //console.log('preselecting dropdown value', entry[mainKey]);
                        preselected = true;
                    }
                });
                if (!preselected) {
                    console.log('preselect for container', type, 'was set to', preselect_1, 'which wasnt found, nothing preselected');
                }
            };
            generateSelection_1();
            dropdownEntries.append(entryFieldsContainer_1);
            dropdownContainer.append(dropdownEntries);
        }
        else {
            console.error("no button in ".concat(type, " container found"));
        }
    }
    else {
        console.error("no #".concat(type, "-container found"));
    }
};
exports._CreateDropdown = _CreateDropdown;
// Define the theme object
exports._Theme = {
    success: {
        background: '#a7f8a8',
        color: '#333',
    },
    info: {
        background: 'rgb(158, 196, 255)',
        color: '#333',
    },
    error: {
        background: '#ffdcd7',
        color: '#333',
    },
    transparent: {
        color: '#333',
    },
};
// Function to create a row element
var _GetRow = function (obj, type, attr) {
    var _a;
    if (attr === void 0) { attr = {}; }
    var themeStyles = {};
    if (type) {
        themeStyles = __assign({ padding: '15px', margin: '20px 0px', borderRadius: '5px' }, exports._Theme[type]);
    }
    return (0, cash_dom_1.default)('<div>' + ((_a = obj === null || obj === void 0 ? void 0 : obj.html) !== null && _a !== void 0 ? _a : '') + '</div>')
        .addClass('m-row' + ((obj === null || obj === void 0 ? void 0 : obj.class) ? ' ' + obj.class : ''))
        .attr(attr)
        .css(__assign(__assign({ width: '100%', display: 'flex', alignItems: 'center' }, themeStyles), obj === null || obj === void 0 ? void 0 : obj.css));
};
exports._GetRow = _GetRow;
// Function to create a column element
var _GetCol = function (colSize, obj) {
    var _a;
    return (0, cash_dom_1.default)('<div>' + ((_a = obj === null || obj === void 0 ? void 0 : obj.html) !== null && _a !== void 0 ? _a : '') + '</div>')
        .addClass('m-col-' + colSize)
        .css(__assign({ width: 'calc(100% / ' + colSize + ')' }, obj === null || obj === void 0 ? void 0 : obj.css));
};
exports._GetCol = _GetCol;
// Function to create a divider line
var _GetDividerLine = function () {
    return (0, cash_dom_1.default)('<div></div>').addClass('divider-line margin');
};
exports._GetDividerLine = _GetDividerLine;
// Function to create a generic element
var _GetGeneric = function (obj) {
    var _a;
    return (0, cash_dom_1.default)('<div>' + ((_a = obj === null || obj === void 0 ? void 0 : obj.html) !== null && _a !== void 0 ? _a : '') + '</div>')
        .addClass((obj === null || obj === void 0 ? void 0 : obj.class) || '')
        .css(__assign({}, obj === null || obj === void 0 ? void 0 : obj.css));
};
exports._GetGeneric = _GetGeneric;
// Function to set up two columns
var _TwoColSetup = function (leftSide, rightSide, css) {
    var row = (0, exports._GetRow)();
    row.append((0, exports._GetCol)(2, { html: leftSide, css: css }));
    row.append((0, exports._GetCol)(2, {
        html: rightSide,
        css: __assign({ textAlign: 'right' }, css),
    }));
    return row;
};
exports._TwoColSetup = _TwoColSetup;
// Function to create phone prefix and country dropdown elements
var _CreateElements = function () {
    (0, exports._GetPhonePrefixDropdown)();
    (0, exports._GetCountryDropdown)();
};
exports._CreateElements = _CreateElements;
// Function to get the phone prefix dropdown
var _GetPhonePrefixDropdown = function () {
    var dataset = countries_const_1._COUNTRIES.map(function (country) { return (__assign({ text: "".concat(translation_1.default.t(country.name), " (").concat(country.prefix, ")") }, country)); });
    (0, exports._CreateDropdown)('phone', 'prefix', dataset, function (country) {
        (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._AllMappings.phonePrefix, country.prefix);
    });
};
exports._GetPhonePrefixDropdown = _GetPhonePrefixDropdown;
// Function to get the country dropdown
var _GetCountryDropdown = function () {
    var dataset = countries_const_1._COUNTRIES.map(function (country) { return (__assign({ text: "".concat(translation_1.default.t(country.name), " (").concat(country.isoCode, ")") }, country)); });
    (0, exports._CreateDropdown)('country', 'isoCode', dataset, function (country) {
        (0, input_output_helper_const_1._SaveFieldInLocalstorage)(input_mapping_const_1._AllMappings.countryCode, country.isoCode);
    });
};
exports._GetCountryDropdown = _GetCountryDropdown;
var _GetComponentLoadingSpinner = function () {
    (0, css_injector_service_1._InjectCss)('_LoadingSpinnerCss', loading_const_1._LoadingSpinnerCss);
    return (0, cash_dom_1.default)('<div class="lds-ring lds-ring-black"><div></div><div></div><div></div><div></div></div>');
};
exports._GetComponentLoadingSpinner = _GetComponentLoadingSpinner;
var _CreateLoadingScreen = function ($container) {
    if ($container === void 0) { $container = (0, cash_dom_1.default)('body'); }
    (0, css_injector_service_1._InjectCss)('_LoadingSpinnerCss', loading_const_1._LoadingSpinnerCss);
    if ($container.find('.full-screen-loading').length === 0) {
        var loader = (0, cash_dom_1.default)('<div class="full-screen-loading"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>');
        (0, cash_dom_1.default)('body').append(loader);
    }
};
exports._CreateLoadingScreen = _CreateLoadingScreen;
var _DeleteLoadingScreen = function ($container) {
    if ($container === void 0) { $container = (0, cash_dom_1.default)('body'); }
    $container.find('.full-screen-loading').remove();
    $container.find('.lds-ring').remove();
    (0, cash_dom_1.default)('.full-screen-loading').remove();
};
exports._DeleteLoadingScreen = _DeleteLoadingScreen;
var _ShowErrorMessage = function (error, errorFieldId) {
    var _a;
    if (errorFieldId === void 0) { errorFieldId = 'error_msg'; }
    var errorFieldObj = (0, cash_dom_1.default)('#' + errorFieldId);
    if (errorFieldObj.length) {
        console.log("adding error to field", errorFieldObj);
        errorFieldObj.text(translation_1.default.t(error));
        errorFieldObj.show();
    }
    else {
        console.error('No error message field defined so we added our own');
        errorFieldObj = (0, exports._GetRow)({
            html: translation_1.default.t(error),
        }, 'error', { id: errorFieldId });
        (_a = (0, jquery_helper_const_1._IsVisible)((0, cash_dom_1.default)('form'))) === null || _a === void 0 ? void 0 : _a.prepend(errorFieldObj);
    }
    (0, helper_const_1._ScrollToPageElement)((0, cash_dom_1.default)('#' + errorFieldId), 120);
};
exports._ShowErrorMessage = _ShowErrorMessage;
var _ShowErrorMessageTimed = function (error, milliseconds, errorFieldId) {
    if (milliseconds === void 0) { milliseconds = 5000; }
    if (errorFieldId === void 0) { errorFieldId = 'error_msg'; }
    (0, exports._ShowErrorMessage)(error, errorFieldId);
    setTimeout(function () { return (0, exports._HideErrorMessage)(errorFieldId); }, milliseconds);
};
exports._ShowErrorMessageTimed = _ShowErrorMessageTimed;
var _HideErrorMessage = function (errorFieldId) {
    if (errorFieldId === void 0) { errorFieldId = 'error_msg'; }
    var errorFieldObj = (0, cash_dom_1.default)('#' + errorFieldId);
    errorFieldObj.text('');
    errorFieldObj.hide();
};
exports._HideErrorMessage = _HideErrorMessage;
